import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductoReferenciaService } from '../../../_services/producto-referencia.service';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import { CuestionarioService } from '../../../_services/cuestionario.service';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { ProductoVinculacionMinimoService } from '../../../_services/producto-vinculacion-minimo.service';
import { ProductoReglaNegocio } from '../../../_models/producto-regla-negocio';
import { ProductoReglaNegocioService } from '../../../_services/producto-regla-negocio.service';
import { ProductoService } from '../../../_services/producto.service';
import { forkJoin } from 'rxjs';

@Component( {
  selector: 'app-producto-regla-negocio',
  templateUrl: 'producto-regla-negocio.component.html'
} )
export class ProductoReglaNegocioComponent implements OnInit {

  @Input() producto: Producto;
  productoReglaNegocio: ProductoReglaNegocio;
  carInformacionInicial = true;
  formulario: FormGroup;
  listaSeleccion: SelectItem[] = [];
  listaProductosReglaNegocio: any [] = [];
  campoMeses = false;
  submitted = false;
  objetoSeleccionado: SelectItem;
  columnas: any [] = [];
  editar = false;
  disabled = true;
  guardando = false;

  constructor( private proReferenciasServicio: ProductoReferenciaService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private cueServicio: CuestionarioService,
               private autServicio: AutenticacionService,
               private serProductoVincualcionMinimo: ProductoVinculacionMinimoService,
               private productoSer: ProductoReglaNegocioService,
               private _producto: ProductoService
  ) {
  }

  ngOnInit(): void {
    forkJoin( this.productoSer.listadoproductosreglanegocio( this.producto.idProducto ) ).subscribe( ( [data] ) => {
      this.listaProductosReglaNegocio = data;
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
    this.completarDatos();
    this.columnas = [
      { field: 'nombreProductoRegla', header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_NOMBREPRODUCTO' ), sort: true },
      {
        field: 'indicadorRecogerCreditos',
        header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_RECOGERCREDITOS' ),
        sort: true
      },
      { field: 'indicadorPrimerCredito', header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_PRIMERCRETIDO' ), sort: true },
      {
        field: 'mesesMaximoCancelacion',
        header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_MESESCANCELACION' ),
        sort: true
      },
      { field: 'porcentajeCancelacion', header: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.LBL_PORCENTAJE' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
  }

  completarDatos( band: boolean = true ) {
    this._producto.listadoHabilitados().subscribe( ( data: any ) => {
      data = data.sort(function (a, b) {
        return a.orden - b.orden;
      });
      data.map( ( m: Producto ) => {
        if ( m.idProducto !== this.producto.idProducto ) {
          const s: any = {
            'value': m.idProducto,
            'label': m.nombre
          };
          this.listaSeleccion.push( s );
        }
      } );
    } );
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProductoReglaNegocio: [this.productoReglaNegocio ? this.productoReglaNegocio.idProductoReglaNegocio : null],
      idProducto: [this.producto.idProducto, [Validators.required]],
      idProductoRegla: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.idProductoRegla : null, [Validators.required]],
      indicadorRecogerCreditos: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.indicadorRecogerCreditos : false],
      indicadorPrimerCredito: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.indicadorPrimerCredito : false],
      indicadorHabilitado: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.indicadorHabilitado : true],
      indicadorPorcentajeCancelacion: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.indicadorPorcentajeCancelacion : false],
      mesesMaximoCancelacion: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.mesesMaximoCancelacion : null, [Validators.required]],
      porcentajeCancelacion: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.porcentajeCancelacion : null],
      nombreProductoRegla: [(this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio) ? this.productoReglaNegocio.nombreProductoRegla : null]
    } );
  }

  onSubmit() {
    this.submitted = true;
    this.guardando = true;
    if ( this.formulario.valid && this.validateReglasNegocio() ) {
      const formulario = this.formulario.getRawValue();
      if ( this.productoReglaNegocio && this.productoReglaNegocio.idProductoReglaNegocio ) {
        this.productoSer.actualizar( formulario ).subscribe( ( data: ProductoReglaNegocio ) => {
          const datos: any = data;
          datos.nombreProductoRegla = this.productoReglaNegocio.nombreProductoRegla;
          const index = this.listaProductosReglaNegocio.findIndex( x => x.idProductoReglaNegocio === data.idProductoReglaNegocio );
          this.listaProductosReglaNegocio[ index ] = datos;
          this.productoReglaNegocio = {} as ProductoReglaNegocio;
          this.editar = false;
          this.guardando = false;
          this.campoMeses = false;
          this.navServicio.setMesage(1);
          this.cargarFormulario();
        } );
      } else {
        this.productoSer.crear( formulario ).subscribe( ( data: ProductoReglaNegocio ) => {
          this.productoReglaNegocio = {} as ProductoReglaNegocio;
          this.guardando = false;
          this.campoMeses = false;
          this.navServicio.setMesage(1);
          this.cargarFormulario();
        } );
      }
      this.submitted = false;
      this.actualizarLista();

    } else {
      this.guardando = false;
    }
  }

  actualizarLista() {
    this.productoSer.listadoproductosreglanegocio( this.producto.idProducto ).subscribe( ( data: any ) => {
      this.listaProductosReglaNegocio = data;
    } );
  }

  cambiarInput( event: boolean ) {
    this.campoMeses = event;
    if ( event ) {
      this.f.mesesMaximoCancelacion.clearValidators();
      this.f.porcentajeCancelacion.setValidators( [Validators.required] );
      this.f.mesesMaximoCancelacion.setValue( null );
    } else {
      this.f.porcentajeCancelacion.clearValidators();
      this.f.mesesMaximoCancelacion.setValidators( [Validators.required] );
      this.f.porcentajeCancelacion.setValue( null );
    }
  }

  get f() {
    return this.formulario.controls;
  }

  AsignarNombre( event: any ) {
    this.objetoSeleccionado = this.listaSeleccion.find( x => x.value === event );
  }

  update( data: ProductoReglaNegocio ) {
    this.editar = true;
    this.productoReglaNegocio = data;
    if ( this.productoReglaNegocio.indicadorPorcentajeCancelacion ) {
      this.campoMeses = true;
    }
    this.cargarFormulario();
    if ( this.editar ) {
      this.cambiarInput( this.productoReglaNegocio.indicadorPorcentajeCancelacion );
    }
  }

  validateReglasNegocio() {
    const indicadorRecogerCreditos = this.f.indicadorRecogerCreditos.value;
    const idProductoRegla = this.f.idProductoRegla.value;
    const indicadorPrimerCredito = this.f.indicadorPrimerCredito.value;
    const indicadorPorcentajeCancelacion = this.f.indicadorPorcentajeCancelacion.value;
    const index = this.listaProductosReglaNegocio.findIndex( x => x.idProductoRegla === idProductoRegla
      && x.indicadorRecogerCreditos === indicadorRecogerCreditos &&
      x.indicadorPrimerCredito === indicadorPrimerCredito
      && x.indicadorPorcentajeCancelacion === indicadorPorcentajeCancelacion );

    if ( index >= 0 ) {
      if ( this.editar ) {
        if ( this.listaProductosReglaNegocio[ index ].idProductoReglaNegocio === this.productoReglaNegocio.idProductoReglaNegocio ) {
          return true;
        } else {
          this.navServicio.setMesage( 0, {
            severity: 'warn', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.MSG_ALERTA' )
          } );
          return false;
        }
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'warn', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTOREGLANEGOCIO.MSG_ALERTA' )
        } );
        return false;
      }
    } else {
      return true;
    }
  }


}
